// @flow

// /file/{fileId}

// export const LOGIN = 'dashboard/LOGIN';
export const SET_ITEMS = 'dashboard/SET_ITEMS';
